import { postRequest } from "./api";
import { API_URL } from "./Environment";

// export const sendEmailAPI = async(payload) => {
//    return postRequest(`${API_URL}chat/contact-us-by-email`,payload)
//       .then((resp) => resp);
// }

export const sendEmailAPI = async (payload) => {
   const formData = new FormData();
 
   // Append all payload data to the formData
   for (const key in payload) {
     formData.append(key, payload[key]);
   }
 
   const response = await fetch(`${API_URL}chat/contact-us-by-email`, {
     method: 'POST',
     headers: {
       Authorization: `Bearer ${sessionStorage.getItem('token')}`,
       // Do not set 'Content-Type' explicitly; fetch will handle it for FormData
     },
     body: formData,
   });
 
   return response;
 };
 